<template>
  <div :class="`main-header`">
    <div class="container">
      <Header />
    </div>
  </div>
  <div :class="`relative`">
    <div
      class="relative banner-background n3-banner-min-height city-bg"
      :style="`background-image: url(&quot;${show.movie.posterUrlLandscape}&quot;);`"
    >
      <div class="card-top-overlay"></div>
      <div class="card-bottom-overlay light"></div>
      <div :class="`flex items-end n3-content-min-height`">
        <div class="container z-10 relative">
          <div class="absolute bottom-[-10pc] w-full">
            <div class="main-subtitle">
              Ongoing
              <span class="text-n3yellow">{{ $route.params.title }} </span> show
              in
            </div>
            <div class="main-title">{{ $route.params.city }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="relative">
    <div class="before-transparent"></div>
  </div>
  <div class="container">
    <div class="my-10 text-[18px] text-justify">
      {{ show.movie.description }}
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div v-for="(show, index) in shows" :key="index">
        <n-3-show-list
          class="cursor-pointer mb-2"
          :class="{
            'cursor-pointer': !show.isPast,
            'opacity-50': show.isPast,
          }"
          :item="{
            title: show.cinema.name,
            image: show.movie.posterUrlSquare,
            subTitle2: show.cinema.street,
            tagOffer: show.tagOffer,
            date: dateTimeFormat(show.start.toDate(), 'DD.MM'),
            time: dateTimeFormat(show.start.toDate(), 'HH:mm'),
          }"
          @click="handleClick(show)"
        />
      </div>
    </div>
  </div>
  <Footer class="hidden sm:block" />
  <component :is="'script'" type="application/ld+json"> {{ jsonLd }}</component>
</template>
<script>
import Header from "@/components/Header.vue";
import { computed, onMounted, reactive, toRefs } from "@vue/runtime-core";
import { useStore } from "vuex";
import { dateTimeFormat, scrollToTop } from "@/utils/helper";
import Footer from "@/components/Footer.vue";
import { useRoute } from "vue-router";
import { useMeta } from "vue-meta";
import N3ShowList from "@/components/home/N3ShowList.vue";
import { useHelper } from "@/composable/useHelper";
import { useGoogleEventCard } from "@/composable/useGoogleEventCard";

export default {
  components: { Header, Footer, N3ShowList },
  setup() {
    const store = useStore();
    const route = useRoute();
    const { navigateToShow } = useHelper();
    const { json, addEvent } = useGoogleEventCard();

    const state = reactive({
      show: computed(() => store.state.show.show),
      shows: computed(() => store.state.show.shows),
      showHeader: computed(() => store.state.event.showHeader),
      jsonLd: computed(() => {
        state.shows.map((a) => {
          addEvent({
            title: a.movie.title,
            start: a.start.toDate(),
            end: a.start.toDate(),
            description: a.movie.description,
            image: a.movie.posterUrlLandscape,
            place: {
              name: a.cinema.name,
              street: a.cinema.street,
              city: a.cinema.city,
              postal: a.cinema.postal,
            },
          });
          return a;
        });

        return json;
      }),
      description: computed(() => {
        let time = [];

        if (state.shows && state.shows.length) {
          state.shows.map((a) => {
            time.push(dateTimeFormat(a.start.toDate(), "hh:mm a"));
          });
        } else {
          time.push(
            state.show.start
              ? dateTimeFormat(state.show.start.toDate(), "hh:mm a")
              : ""
          );
        }

        let des = [
          `${route.params.title} movie show is a highly anticipated event in ${route.params.city}. Check out the schedule and book your tickets in advance to enjoy this exciting cinematic experience in the vibrant city of ${route.params.city}`,
          `Check the available ${route.params.title} show times at ${time.join(
            ", "
          )}. find the perfect time to catch the ${route.params.title} show`,
        ];
        return des.join(". ");
      }),
      keywords: computed(() => {
        let keys = [`${route.params.title} show time in ${route.params.city}`];
        return keys.join(", ");
      }),
    });

    useMeta(
      computed(() => ({
        title: `${route.params.title} Show Times in ${route.params.city}`,
        description: state.description,
        meta: [
          {
            name: "keywords",
            content: state.keywords,
          },
        ],
      }))
    );

    onMounted(async () => {
      store.dispatch("show/findByCityAndMovie", {
        city: route.params.city,
        title: route.params.title,
      });
      scrollToTop();
    });

    function handleClick(show) {
      if (show.isPast) return;
      navigateToShow(show.slug, show.tickets ? "standing" : "seat");
    }

    return {
      ...toRefs(state),
      dateTimeFormat,
      handleClick,
    };
  },
};
</script>
